import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
var FontPreloader = function (props) {
    var _a = useState(true), visible = _a[0], setVisible = _a[1];
    var fontsArray = ['osoSans'];
    useEffect(function () {
        setTimeout(function () {
            // setVisible(false);
            props.onFontLoad();
        }, 10);
    }, []);
    return visible ? (_jsx("div", { id: "fontPreloader", style: { position: 'absolute', opacity: 0 }, children: fontsArray.map(function (font, index) { return (_jsx("div", { "aria-hidden": "true", style: { fontFamily: font }, children: "font".concat(index) }, "".concat(index))); }) })) : (null);
};
export default FontPreloader;
